import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import styles from './Dashboard.module.css';
import Form from './form/Form';
import FormGroup from './form-group/FormGroup';
import pageData from './formData';
import { getPageIdByName } from '../../../_metronic/helpers/utils/api';

const Dashboard = () => {
  const location = useLocation();
  const [pageName, section] = location.pathname.split('/').slice(2, 4);
  const sectionName = section ?? pageName;
  const formData = pageData[`${pageName}Data`][`${sectionName}Data`];

  const [pageId, setPageId] = useState(1);
  useEffect(() => {
    const fetchPageId = async () => {
      const id = await getPageIdByName(pageName);
      setPageId(id ?? 0);
    };

    void fetchPageId();
  }, [pageName]);

  const getTitle = () => {
    return pageName.toLowerCase() === sectionName.toLowerCase()
      ? pageName
      : `${pageName} ${sectionName}`;
  };

  return (
    <main className={styles.container}>
      <h1 className={styles.title}>{getTitle()}</h1>

      {formData.map((item) =>
        item.formId.startsWith('formGroup') ? (
          <FormGroup
            key={`${pageName}-${sectionName}-${item.formId}`}
            formId={item.formId}
            inputData={item.data}
            heading={item.heading}
            pageId={pageId}
            sectionName={sectionName}
          />
        ) : (
          <Form
            key={`${pageName}-${sectionName}-${item.formId}`}
            formId={item.formId}
            inputData={item.data}
            heading={item.heading}
            pageId={pageId}
            sectionName={sectionName}
          />
        )
      )}
    </main>
  );
};

export default Dashboard;
